module.exports = __webpack_public_path__ + "static/media/woman_03.0a48da53.png";